module.exports = __webpack_public_path__ + "media/assets/images/authors/federico_gobbo-866bfee5d170867b0b6fad99fbd79c71.jpg";